import { render, staticRenderFns } from "./setTask.vue?vue&type=template&id=cd0ec95a&scoped=true&"
import script from "./setTask.vue?vue&type=script&lang=js&"
export * from "./setTask.vue?vue&type=script&lang=js&"
import style0 from "./setTask.vue?vue&type=style&index=0&id=cd0ec95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0ec95a",
  null
  
)

export default component.exports